import "assets/styles/reports/balanceSheet.scss";
import { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material";
import { useAppDispatch, useAppSelector } from "store/store";
import ReactToPrint from "react-to-print";
import useRemittancePrint from "./useRemittancePrint";
import BasicButton from "../../BasicInputs/BasicButton";
import { apiGetRemittance, apiGetRemittanceByFactorId } from "../../../api/remittanceApi";

const ItemContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: "36px",
}));

export default function RemittancePrint({
    remittanceId,
    remittanceType,
    autoPrint,
    factorId,
}: {
    remittanceId?: string | number;
    remittanceType: string;
    autoPrint?: boolean;
    factorId?: string | number
}) {
    const dispatch = useAppDispatch();
    const store = useAppSelector((state: any) => state);
    const business = store.businessReducer?.business;
    const { token } = business;

    const [remittance, setRemittance] = useState<any[]|null>(null);
    const [remittanceIsFetched, setRemittanceIsFetched] = useState(false);
    const callBack = (remittance: any) => {
        if (!Array.isArray(remittance))
            setRemittance([remittance])
        else setRemittance(remittance)
        return setRemittanceIsFetched(true);
    };

    const printRef = useRef<any>(null);
    const { contentRef, content } = useRemittancePrint({ remittances: remittance });

    useEffect(() => {
        if (remittanceId) {

            dispatch(apiGetRemittance(remittanceId, token, callBack));
        } else if (factorId) {
            dispatch(apiGetRemittanceByFactorId(factorId, ((res: any) => {
                callBack(res.bills)
            })));
        }
    }, [token]);

    useEffect(() => {
        if (remittanceIsFetched && autoPrint) printRef.current.handleClick();
    }, [remittanceIsFetched]);

    return (
        <ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
            <div className="hidden">{content}</div>
            <ReactToPrint
                ref={printRef}
                trigger={() => (
                    <BasicButton fullWidth variant="outlined">
                        <span>چاپ رسید / حواله انبار</span>
                    </BasicButton>
                )}
                content={() => contentRef.current}
            />
        </ItemContainer>
    );
}
